module.exports = __webpack_public_path__ + "3917d5ff561e8e39634dcfae67a0758e.jpg";